/**
 * Hook para cambiar de empresa activa desde el switcher (topbar / drawer móvil).
 *
 * Encapsula: llamar a `switchCompany`, llevar el estado "cambiando" por empresa,
 * navegar al inicio (la ruta actual puede ser de un recurso de la empresa
 * anterior) y avisar al llamador para el feedback ("Cambiaste a X").
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from './auth/AuthProvider';
import type { CompanyMembership } from './auth/types';

export function useCompanySwitch(onSwitched?: (name: string) => void) {
  const { switchCompany, company } = useAuth();
  const navigate = useNavigate();
  const [switchingId, setSwitchingId] = useState<string | null>(null);

  const run = async (target: CompanyMembership) => {
    // Ya estamos en esa empresa: no-op (evita rotar el refresh sin motivo).
    if (target.id === company?.id || switchingId) return;
    setSwitchingId(target.id);
    try {
      const next = await switchCompany(target.id);
      navigate('/inicio');
      onSwitched?.(next.name);
    } finally {
      setSwitchingId(null);
    }
  };

  return { switchingId, run };
}
